<template>
    <div v-loading="dataLoading">
        <el-alert type="warning" :closable="false">
            <div slot="title">
                Dashboard上新版了啦！
                <router-link to="/workbench/dashboard" class="color-danger">马上体验<i class="el-icon-right"></i></router-link>
            </div>
        </el-alert>
        <div class="page-tab-box">
            <el-tabs v-model="activeName" type="card" @tab-click="clickEvent" class="MR20">
                <el-tab-pane v-for="(item,index) in interval" :key="index" :label="tabName.get(item.timeInterval)" :name="item.timeInterval.toString()"></el-tab-pane>
            </el-tabs>
            <el-date-picker v-model="daterange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" 
                size="small" value-format="yyyy-MM-dd" @change="daterangeChange" :clearable="false" unlink-panels :picker-options="pickerOptions">
            </el-date-picker>
        </div>
        <div v-if="intervalData && daterange.length < 1" class="page-group-title">
            <span>{{intervalData.startTime}} <template  v-if="intervalData.startTime != intervalData.endTime"> 至 {{intervalData.endTime}}</template></span>
        </div>
        <div v-else class="page-group-title">
            <span>{{daterange[0]}} 至 {{daterange[1]}}</span>
        </div>
        <template v-if="intervalData">
            <Overview v-if="$utils.have('/dashboard/overview')" :intervalData="intervalData" :daterange="daterange" class="data-group MT20"></Overview>
            <HotData v-if="$utils.have('/dashboard/hotData')" :intervalData="intervalData" :daterange="daterange" class="data-group MT20"></HotData>
            <ActivitySales v-if="$utils.have('/dashboard/activitySales')" :intervalData="intervalData" :daterange="daterange" class="data-group MT20"></ActivitySales>
            <ActivitySalesRank v-if="$utils.have('/dashboard/salesRank')" :intervalData="intervalData" :daterange="daterange" class="data-group MT20"></ActivitySalesRank>
            <Fans v-if="$utils.have('/dashboard/newFans')" :intervalData="intervalData" :daterange="daterange" class="data-group MT20"></Fans>
            <GoodsSales v-if="$utils.have('/dashboard/goodsdata')" :intervalData="intervalData" :daterange="daterange" class="data-group MT20"></GoodsSales>
            <GoodsSalesRank v-if="$utils.have('/dashboard/goodsdata/rank')" :intervalData="intervalData" :daterange="daterange" class="data-group MT20"></GoodsSalesRank>
            <BUser v-if="$utils.have('/dashboard/newBUser')" :intervalData="intervalData" :daterange="daterange" class="data-group MT20"></BUser>
            <!-- <Opinion v-if="$utils.have('/dashboard/activityletter') || $utils.have('/dashboard/fanssuggest') || $utils.have('/dashboard/raiseletter')" :intervalData="intervalData" :daterange="daterange" class="data-group MT20"></Opinion> -->
            <!-- <ActivityData v-if="$utils.have('/dashboard/activitydata')" :intervalData="intervalData" :daterange="daterange" class="data-group MT20"></ActivityData> -->
            <RaiseData v-if="$utils.have('/dashboard/raisedata')" :intervalData="intervalData" :daterange="daterange" class="data-group MT20"></RaiseData>
        </template>
    </div>
</template>

<script>
import Overview from './components/overview';
import HotData from './components/hot-data';
import ActivitySales from './components/activity-sales';
import ActivitySalesRank from './components/activity-sales-rank';
import Fans from './components/fans';
import GoodsSales from './components/goods-sales';
import GoodsSalesRank from './components/goods-sales-rank';
import BUser from './components/b-user';
import ActivityData from './components/activity-data';
import RaiseData from './components/raise-data';
import Opinion from './components/opinion';

export default {
    components: { Overview, HotData, ActivitySales, ActivitySalesRank, Fans, GoodsSales, GoodsSalesRank, BUser, ActivityData, RaiseData, Opinion},
    name: "dashboard",
    data() {
        return {
            dataLoading: false,
            interval: [],
            activeName: '30',
            intervalData: null,
            daterange: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            }
        };
    },
    computed:{
        tabName(){
            return new Map([
                [-1,'昨日'],[1,'今日'],[7,'最近7天'],[30,'最近30天'],[90,'最近90天'],[180,'最近180天'],[360,'最近360天']
            ])
        }
    },
    created(){
		this.getInterval();       
    },
    methods:{
        //获取时间间隔
        getInterval(){
            // this.dataLoading = true
			if(!this.$utils.have('/dashboard/interval')){				
				return;
			}
			if(this.$utils.have('/dashboard/interval')){
				this.$request({
					url: "/dashboard/interval",
					method: "POST",
				})
					.then((res) => {
						const { state, msg, result } = res.data;
						if (state == 1 && result) {
							this.interval = result.filter(v => v.timeInterval > -2);
							this.intervalData = this.interval.find(v => v.timeInterval == this.activeName);
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			}
        },
        clickEvent(tab){
            this.daterange = [];
            this.intervalData = this.interval.find(v => v.timeInterval == tab.name);
        },
        daterangeChange(e){
            this.activeName = "";
            this.intervalData = {
                ...this.intervalData,
                startTime: e[0],
                endTime: e[1],
                timeInterval: ""
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.page-tab-box{
    margin: 20px -20px 20px -20px;
    padding: 0 20px;
    border-bottom: 1px #E4E7ED solid;
    display: flex;
    align-items: center;
    ::v-deep .el-tabs__header{
        border-bottom: 0;
        margin: 0;
    }
}
.data-group{
    > ::v-deep .el-card__header{
        font-size: 16px;
        line-height: 22px;
        a{
            font-size: 14px;
        }
    }
}
</style>